let cachedSessionId: string | null = null;

function generateUuidFallback(): string {
    return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2)}`;
}

/**
 * Returns a session id that is unique per page context (each tab, window, and reload).
 *
 * The value is held in memory only - it is intentionally NOT persisted to
 * sessionStorage/localStorage. This guarantees every tab/window gets its own id
 * (sessionStorage is copied into tabs opened from an existing tab, so it cannot
 * provide per-tab uniqueness). The trade-off is that a full page reload starts a
 * new session id.
 */
export function getOrCreateSessionId(): string {
    if (cachedSessionId === null) {
        cachedSessionId = typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
            ? crypto.randomUUID()
            : generateUuidFallback();
    }

    return cachedSessionId;
}
